/*
 * Enum.
 */

// Please ask a data analyst before adding new values.

export enum DataEventActionsEnum {
  // User clicks on a + button
  ADD = 'add',
  // User clicks on an interface element (other than CTA)
  CLICK = 'click',
  // User clicks on the standard UI elements for closing modals, views, prompts
  CLOSE = 'close',
  COLLAPSE = 'collapse',
  EXPAND = 'expand',
  // Hovering an object making something appearing (tooltip)
  HOVER = 'hover',
  OPEN_URL = 'open_url',
  OUTCOME = 'outcome',
  // User selects an item (in a dropdown, in a menu)
  SELECT = 'select',
  // Asynchronous work begins (eg: concurrent Copilot stream; PB-73567)
  START = 'start',
  // Scrolling over a list of object
  SCROLL = 'scroll',
  // Generic passive action when an asynchronous task completes (eg: rule creation)
  SUCCESS = 'success',
  // User is exposed to something (screen, screen element, ...)
  VIEW = 'view',
  COPY = 'copy',
  KEYBOARD_SHORTCUT = 'keyboard_shortcut',
}
